import * as React from 'react';
import { useState } from 'react';
import Button from '../../../common/form/Button';
import InputWithValidationIcon from '../../../common/form/InputWithValidationIcon';

interface Props {
    labelText: string;
    buttonText: string;
    onSubmit: (password: string) => Promise<boolean>;
    setErrorMessage: (error: string) => void;
}

const ProspectNewPasswordEntry = (props: Props) => {
    const [passwordOneInput, setPasswordOneInput] = useState<string>('');
    const [passwordTwoInput, setPasswordTwoInput] = useState<string>('');
    const [wasFormValidated, setWasFormValidated] = useState<boolean>(false);

    const validatePasswordInput = (password: string) => {
        let numRequirementsMet = 0;

        if (password.length < 6) {
            return 'Needs more characters';
        }

        if (password.length > 30) {
            return 'Needs fewer characters';
        }

        if (password.toUpperCase() !== password) {
            numRequirementsMet += 1;
        }

        if (password.toLowerCase() !== password) {
            numRequirementsMet += 1;
        }

        if (/\d/.test(password)) {
            numRequirementsMet += 1;
        }

        if (/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(password)) {
            numRequirementsMet += 1;
        }

        return numRequirementsMet;
    };

    const passwordOneValidationResult = validatePasswordInput(passwordOneInput);

    const passwordTwoIsValid =
        passwordOneInput.localeCompare(passwordTwoInput) === 0 && passwordTwoInput.length > 0;

    return (
        <div>
            <InputWithValidationIcon
                labelText="Create Password"
                helpText={
                    'Minimum 6 characters - upper and lower case ' +
                    'plus a number or special character'
                }
                name="passwordOne"
                value={passwordOneInput}
                onChange={(_, value) => setPasswordOneInput(value.toString())}
                placeholder="New password"
                showIcon={wasFormValidated}
                validIcon={
                    typeof passwordOneValidationResult === 'number' &&
                    passwordOneValidationResult >= 3
                }
                type="password"
                invalidIconText={
                    typeof passwordOneValidationResult === 'number'
                        ? passwordOneValidationResult < 3
                            ? `${passwordOneValidationResult} of 4 requirements met`
                            : undefined
                        : passwordOneValidationResult
                }
            />
            <InputWithValidationIcon
                labelText="Confirm Password"
                name="passwordTwo"
                value={passwordTwoInput}
                onChange={(_, value) => setPasswordTwoInput(value.toString())}
                placeholder="Confirm password"
                showIcon={wasFormValidated}
                validIcon={passwordTwoIsValid}
                type="password"
                invalidIconText="Passwords don't match"
            />
            <div className="prospect-auth-button-container">
                <Button
                    text={props.buttonText}
                    addlClassName="btn-full-width btn-primary"
                    removeBoldFont={true}
                    onClick={() => {
                        setWasFormValidated(true);
                        if (passwordOneValidationResult >= 3 && passwordTwoIsValid) {
                            props.onSubmit(passwordOneInput);
                        }
                    }}
                    disabled={
                        !wasFormValidated
                            ? passwordOneInput.length === 0 || passwordTwoInput.length === 0
                            : passwordOneInput.localeCompare(passwordTwoInput) !== 0 ||
                              passwordOneInput.length === 0
                    }
                />
            </div>
        </div>
    );
};

export default ProspectNewPasswordEntry;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/ProspectNewPasswordEntry.tsx